import BaseView from '../components/accordion-list/director';
import AnalyticsDecorate from '../../../analytics/decorate';
import RestrictDecorate from '../../../facade/restrictions/decorate';

module.exports = AnalyticsDecorate(require('./analytics/view'),
  RestrictDecorate(require('./restrict/view'), BaseView.extend({
    class: 'import',
    uploadViewKey: 'all',
    views: {},
    Views: {
      image: require('./contents/image'),
      text: require('./contents/text'),
      icon: require('./contents/icon')
    },
    buttons: [
      {
        key: 'images',
        tag: 'tool.import.image'
      },
      {
        key: 'text',
        tag: 'tool.import.text'
      },
      {
        key: 'icons',
        tag: 'tool.import.svg'
      }
    ],

    beforeSubmitEvent: function (event) {
      this.canUse || event.preventDefault();
    },

    initialize: function (opts) {
      this.canUse = opts.canUse;
      _.bindAll(this, 'beforeSubmitEvent');
    },

    render: function () {
      BaseView.prototype.render.call(this);
      this.canUse || this.initHelper();
    },

    refresh: function () {
      _.each(this.views, function (view) {
        if (view.refresh) {
          view.refresh();
        } else if (view.masonryReload) {
          view.masonryReload();
        }
      });
    },

    showCantUseModal: function () {
      INKIVE.Helpers.displaySubscriptionModal('tool.import.helper.description');
    },

    loadImportedListContent: function (key, $button) {
      const getNewImportedListContainer = function () {
        const $title = $('<div class="section-title imported">' +
          '<span>' +
          INKIVE.TranslateHelper.translate('tool.import.' + key) +
          '</span>' +
          '</div>').css('visibility', 'hidden');

        const $container = $('<div></div>')
          .addClass('image-list content ' + key);

        $button.parent().siblings('.imported-elements').append($title);
        $container.insertAfter($title);

        return $container;
      };

      if (this.canUse || key === 'image') {
        this.views[key] = new this.Views[key]({
          el: getNewImportedListContainer(),
          $uploadButton: $button,
          type: key,
          premium: this.canUse
        });
      }

      if (this.canUse) {
        $button.addClass('enabled');
      } else {
        key === 'image' || $button.siblings('.drag-drop-file').hide();
        $button.on('click', this.showCantUseModal);
      }
    }
  })));
